import { startOwnerTeamApp } from './appBootstrap.js';

startOwnerTeamApp({
  location: window.location,
  loadApp: () => import('./main.jsx')
});
